import { createUseStyles } from 'react-jss'

import { fontWeightBold } from '../../../../../../../styles/typography'

const useStyles = createUseStyles({
  subTitle: {
    fontWeight: fontWeightBold,
    color: ['#000', '!important'],
    fontSize: 16,
    marginTop: [0, '!important']
  }
})

export default useStyles
